import { useQuery } from "@tanstack/react-query"
import { listSnippets } from "sdk/snippets"

export function useListSnippets() {
  return useQuery({
    queryKey: ["snippets"],
    queryFn: listSnippets,
    staleTime: 10000
  })
}
